import React, { ReactNode, useContext, useState } from 'react';
import GlobalModal from '../components/modals/GlobalModal';

export interface IUModalConfig {
  contents: ReactNode;
  title?: ReactNode;
  submitText?: string;
  cancelText?: string;
  showCancel?: boolean;
  isError?: boolean;
  onSubmit?: () => void;
  onHide?: () => void;
}

export interface IUModalContext {
  showModal: (config: IUModalConfig) => void;
  hideModal: () => void;
}

/* istanbul ignore next */
const ModalContext = React.createContext<IUModalContext>({
  showModal: () => null,
  hideModal: () => null
});

export function ModalContextProvider(props: { children: React.ReactNode }) {
  const [config, setConfig] = useState<IUModalConfig | null>(null);

  const context: IUModalContext = {
    showModal: setConfig,
    hideModal: () => {
      setConfig(null);
    }
  };

  return <ModalContext.Provider value={context}>
    {config ? <GlobalModal config={config} onHide={context.hideModal}/> : null}
    {props.children}
  </ModalContext.Provider>;
}

export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (context === null) {
    throw new Error('useModalContext must be used within a ModalContextProvider');
  }
  return context;
};

export default ModalContext;
